import type { JobDetail } from '@/types'
import styles from './nodeDetail.module.css'
import { cx } from './utils'

interface CurrentJobsProps {
  recordingJobs: JobDetail[]
  uploadJob: JobDetail | null
}

export function CurrentJobs({ recordingJobs, uploadJob }: CurrentJobsProps) {
  if (recordingJobs.length === 0 && !uploadJob) {
    return (
      <div className={styles.card}>
        <div className={styles.cardTitle}>Current Jobs</div>
        <p className={styles.modelCommandEmptyText}>No active jobs</p>
      </div>
    )
  }

  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>Current Jobs</div>
      <div className={styles.currentJobsList}>
        {recordingJobs.map((job) => <JobCard key={job.id} job={job} />)}
        {uploadJob && <JobCard job={uploadJob} />}
      </div>
    </div>
  )
}

function JobCard({ job }: { job: JobDetail }) {
  const elapsed = job.started_at
    ? Math.floor((Date.now() - new Date(job.started_at).getTime()) / 1000)
    : null

  function formatElapsed(s: number): string {
    if (s < 60) return `${s}s`
    if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`
    return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`
  }

  return (
    <div className={styles.jobCard}>
      <div className={cx(
        styles.jobType,
        job.type === 'recording' ? styles.jobTypeRecording : styles.jobTypeUpload,
      )}>
        {job.type}
      </div>
      <div className={styles.jobMeta}>
        Status: <strong>{job.status}</strong>
      </div>
      {job.pid != null && (
        <div className={styles.jobMeta}>
          PID: <code>{job.pid}</code>
        </div>
      )}
      {elapsed != null && (
        <div className={styles.jobMeta}>
          Running: {formatElapsed(elapsed)}
        </div>
      )}
      {job.progress != null && (
        <div className={styles.progressBlock}>
          <div className={styles.progressLabel}>Progress</div>
          <div className={styles.progressRow}>
            <div className={styles.progressTrack}>
              <div
                className={styles.progressFill}
                style={{
                  width: `${Math.min(job.progress, 100)}%`,
                }}
              />
            </div>
            <span className={styles.progressValue}>{job.progress.toFixed(0)}%</span>
          </div>
        </div>
      )}
    </div>
  )
}
